// components/discovery/DiscoveryStats.jsx
import React from 'react';

const DiscoveryStats = ({ stats, loading }) => {
    return (
        <div className="mt-4 grid grid-cols-3 gap-4">
            <div className="bg-white p-4 rounded-lg shadow">
                <div className="text-sm text-gray-600">Total Games</div>
                <div className="text-2xl font-bold">
                    {stats.processed.toLocaleString()}/{stats.total.toLocaleString()}
                </div>
            </div>
            <div className="bg-white p-4 rounded-lg shadow">
                <div className="text-sm text-gray-600">Processing Status</div>
                <div className="text-2xl font-bold">
                    {loading ? 'Processing...' : 'Ready'}
                </div>
            </div>
            <div className="bg-white p-4 rounded-lg shadow">
                <div className="text-sm text-gray-600">Matching Games</div>
                <div className="text-2xl font-bold">{stats.matching.toLocaleString()}</div>
            </div>
        </div>
    );
};

export default DiscoveryStats;